export default __webpack_public_path__ + "static/media/trashcan.24bf259b.svg";